import { useEffect, useState } from "react";
import Reveal from "@/components/Reveal";
import SectionEyebrow from "@/components/SectionEyebrow";
import Seo from "@/components/Seo";
import { WorkshopCard } from "@/components/UpcomingWorkshops";
import { fetchWorkshops } from "@/lib/api";
import { breadcrumbJsonLd } from "@/lib/seo";

export default function Workshops() {
    const [items, setItems] = useState(null);
    useEffect(() => { fetchWorkshops().then(setItems).catch(() => setItems([])); }, []);
    return (
        <div data-testid="workshops-page" className="relative">
            <Seo
                title="Business Growth Workshops for Teams & Founders | Abhijit JK"
                description="Practical business growth workshops by Abhijit JK — brand, website, social media, content and team training. Online, offline and hybrid formats for founders, MSMEs and teams."
                path="/workshops"
                jsonLd={[breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Workshops", path: "/workshops" }])]}
            />
            <section className="mx-auto max-w-7xl px-6 pt-16 pb-10 lg:px-10">
                <Reveal><SectionEyebrow>Workshops & Programs</SectionEyebrow></Reveal>
                <Reveal delay={0.1}>
                    <h1 className="mt-6 max-w-3xl font-display text-4xl font-semibold leading-[1.08] tracking-tighter sm:text-5xl lg:text-6xl">
                        Practical workshops that make teams{" "}
                        <span className="gold-text">think growth.</span>
                    </h1>
                </Reveal>
                <Reveal delay={0.15}>
                    <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/65 md:text-lg">
                        Hands-on programs on branding, websites, social media, content and business
                        growth — built from 15+ years of real consulting experience. Online, offline
                        at your office, or hybrid.
                    </p>
                </Reveal>
            </section>
            <section className="mx-auto max-w-7xl px-6 pb-24 lg:px-10">
                {items === null ? (
                    <p className="text-white/50">Loading workshops…</p>
                ) : items.length === 0 ? (
                    <div className="glass rounded-lg p-10 text-center text-white/60" data-testid="workshops-empty">
                        New workshops are being planned. Follow along or book a consultation meanwhile.
                    </div>
                ) : (
                    <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                        {items.map((w) => <Reveal key={w.id}><WorkshopCard w={w} /></Reveal>)}
                    </div>
                )}
            </section>
        </div>
    );
}
